export const WorkflowRail = ({steps}) => (
    <aside className="admin-rail">
        {steps.map((step) => (
            <div className="admin-rail-step" key={step.title}>
                <strong>{step.title}</strong>
                <span>{step.copy}</span>
            </div>
        ))}
    </aside>
);
